import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  songArtistNames: {
    display: 'flex',
    flexDirection: 'column',
    color: 'var(--text-primary)',
    maxWidth: '200px',

    '&.clickable': {
      cursor: 'pointer',
    },

    '@media screen and (min-width: 1441px)': {
      maxWidth: '350px',
    },

    '@media screen and (min-width: 1600px)': {
      maxWidth: '400px',
    },
  },

  songName: {
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '18.2px',

    '&': {
      ...mixins.longText,
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },

  artistName: {
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '16px',

    '&': {
      ...mixins.longText,
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '16px',
    },
  },

  extraInfoTooltip: {
    pointerEvents: 'none',

    '& .rc-tooltip-inner': {
      padding: '4px 6px',
    },

    '& *': {
      pointerEvents: 'none',
    },
  },

  extraInfoTooltipContent: {
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    '& .label': {
      display: 'flex',
      flexDirection: 'row',
      color: 'var(--text-hint)',
      fontSize: '11px',
      lineHeight: '15.59px',

      '&:not(:last-child)': {
        margin: '0 0 4px 0',
      },

      '& span': {
        color: 'var(--text-primary)',
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
        textAlign: 'left',
        padding: '0 0 0 4px',
      },

      '@media screen and (min-width: 1441px)': {
        fontSize: '14px',
        lineHeight: '19.6px',
      },
    },
  },
}));

export default useStyles;
